export const MAIN_WEBSITE_URL = 'https://kaspreadsheet.com';
export const SITE_URL = 'https://usfanslink.team';